import urlParser from '../urlParser';
// import websiteJson from '../../../config/website.json';

// const branchHomePageLink = (branchClass) => {
//	const domainInfo = websiteJson.domain[process.env.NODE_ENV.toLowerCase()][{
//		'-xin': 'xinzhuang',
//		'-tao': 'taoyuan',
//		'-kao': 'kaohsiung',
//		'-hua': 'hualien',
//	}[branchClass]];

//	if (branchClass === '-kao') {
//		return `${
//			domainInfo.ssl ? 'https' : 'http'
//		}://${domainInfo.value}${window.location.pathname}`;
//	}

//	return `${
//		domainInfo.ssl ? 'https' : 'http'
//	}://${domainInfo.value}`;
// };

const changeLanguagePath = (element) => {
	window.location.href = window.location.href.replace(
		`/${urlParser.language}/`,
		`/${element.classList[1].substr(1, 2)}/`,
	);
};

const initNavigationDropdownList = () => {
	/**
	 * branch list
	 */
	// document.querySelector(`.dropdown-button.-branch > .list > .option.-${urlParser.branch.substr(0, 3)}`)
	//	.classList.add('-active', 'noshow');

	// if (!process.env.DEV) {
	//	Array.from(document.querySelectorAll('.dropdown-button.-branch > .list > .option:not(.-active)'))
	//		.forEach((optionElement) => {
	//			optionElement.setAttribute('href', branchHomePageLink(optionElement.classList[1]));
	//		});
	// }

	/**
	 * language list
	 */
	document.querySelector(`.dropdown-button.-language > .list > .option.-${urlParser.language}`)
		.classList.add('-active');

	Array.from(document.querySelectorAll('.dropdown-button.-language > .list > .option:not(.-active)'))
		.forEach((optionElement) => {
			optionElement.addEventListener('click', (e) => changeLanguagePath(e.target));
		});
};

export default initNavigationDropdownList;



// WEBPACK FOOTER //
// ./src/js/common/initNavigationDropdownList.js